/**
 * FreeTextStep Component
 *
 * Step 3C: Free-form text input for assessment context.
 */

import { WizardState, WIZARD_LIMITS } from './types';

interface FreeTextStepProps {
  state: WizardState;
  onChange: (updates: Partial<WizardState>) => void;
  errors: string[];
}

export function FreeTextStep({ state, onChange, errors }: FreeTextStepProps) {
  return (
    <div>
      <h2 style={{ marginBottom: 8 }}>Training Materials</h2>
      <p className="text-muted" style={{ marginBottom: 24 }}>
        Paste any relevant content that should inform the assessment. This could include training
        materials, job descriptions, competency frameworks, or other reference material.
      </p>

      {errors.length > 0 && (
        <div className="error-box" style={{ marginBottom: 16 }}>
          {errors.map((err, i) => (
            <div key={i}>{err}</div>
          ))}
        </div>
      )}

      <div className="form-group">
        <label className="label">Content</label>
        <textarea
          className="input"
          value={state.additionalContext}
          onChange={(e) => onChange({ additionalContext: e.target.value })}
          placeholder="Paste training content, job descriptions, competency frameworks, or any reference material that should inform the assessment..."
          rows={12}
          maxLength={WIZARD_LIMITS.ADDITIONAL_CONTEXT_MAX}
          style={{ width: '100%', maxWidth: 700, fontFamily: 'inherit' }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 8,
          }}
        >
          <p className="text-muted text-small">
            AI will use this context to generate competencies, scenarios, and rubrics.
          </p>
          <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
            {state.additionalContext.length} / {WIZARD_LIMITS.ADDITIONAL_CONTEXT_MAX}
          </span>
        </div>
      </div>

      {/* Suggestions */}
      <div
        style={{
          padding: 16,
          background: 'var(--bg-muted)',
          borderRadius: 8,
          marginTop: 16,
        }}
      >
        <h4 style={{ margin: '0 0 8px', fontSize: 13 }}>What to include:</h4>
        <ul
          style={{
            margin: 0,
            paddingLeft: 20,
            fontSize: 13,
            color: 'var(--text-secondary)',
            lineHeight: 1.6,
          }}
        >
          <li>Key skills or competencies being trained</li>
          <li>Typical scenarios or situations learners will face</li>
          <li>Expected behaviors or responses</li>
          <li>Company policies or constraints</li>
          <li>Success criteria or performance standards</li>
        </ul>
      </div>
    </div>
  );
}
